import { hasPendingArenaInvitation } from "../arenaInvitation/pendingArenaInvitation";

/**
 * True when this location is an arena invite, share link, or live session.
 * Sport selection must not replace these with Home.
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 */
export function isArenaEntryLocation(location) {
  const path = String(location?.pathname || "");
  const search = String(location?.search || "");
  if (path.startsWith("/join/")) return true;
  if (path.startsWith("/room/")) return true;
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  const room = String(params.get("room") || "").trim();
  if (room && (path === "/" || path === "/play")) return true;
  return hasPendingArenaInvitation();
}
